"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudentCourseCard = void 0;
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var il_grading_task_bar_1 = require("../il-grading-task-bar/il-grading-task-bar");
var il_student_card_1 = require("../il-student-card/il-student-card");
var il_navigation_banner_common_1 = require("../il-navigation-banner/il-navigation-banner.common");
var il_spinner_1 = require("../il-spinner/il-spinner");
var course_activity_summary_common_1 = require("../course-activity-summary/course-activity-summary.common");
function StudentCourseCard(_a) {
    var courses = _a.courses, _b = _a.showGradingTaskbar, showGradingTaskbar = _b === void 0 ? false : _b, overrideNoCoursesComponent = _a.overrideNoCoursesComponent, children = _a.children, disabledGradingTaskbar = _a.disabledGradingTaskbar, props = __rest(_a, ["courses", "showGradingTaskbar", "overrideNoCoursesComponent", "children", "disabledGradingTaskbar"]);
    var classes = 'student-course-card ' + props.className;
    var NoCourseComponent = overrideNoCoursesComponent;
    if (!overrideNoCoursesComponent) {
        NoCourseComponent = (react_1.default.createElement(il_navigation_banner_common_1.NoCoursesAssigned, { subtitle: 'No Recent Assignments Completed',
            description: (react_1.default.createElement(material_1.Box, { sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                    alignItems: 'center',
                    mb: '1.5rem',
                } },
                react_1.default.createElement(material_1.Typography, { fontSize: "body1" }, "Encourage your student to get started."))) }));
    }
    return (react_1.default.createElement(material_1.Box, { className: classes, sx: { mt: 2.1 } },
        react_1.default.createElement(material_1.Box, { sx: __assign({ display: 'flex', flexDirection: 'column', backgroundColor: 'background.paper', borderBottomLeftRadius: '1.85rem', borderBottomRightRadius: '1.85rem', boxShadow: '0px 3px 8px #999;', gap: 1 }, props.sx) },
            react_1.default.createElement(il_student_card_1.ILStudentCard, __assign({}, props, { sx: { mt: -2 } })),
            showGradingTaskbar && (react_1.default.createElement(il_grading_task_bar_1.ILGradingTaskBar, __assign({}, props, { disabled: props.disabled || disabledGradingTaskbar, sx: { my: 0.75 } }))),
            courses && courses.length > 0 && (react_1.default.createElement(material_1.Box, { sx: { px: 2, pb: 2.5, display: 'flex', flexDirection: 'column', gap: 1 } }, courses.map(function (course, idx) { return (react_1.default.createElement(course_activity_summary_common_1.CourseCardSummaryPopUp, __assign({ key: idx }, course, { sx: {
                    '&.il-course-card': __assign({ boxShadow: 0, border: 'solid 0.06875rem', borderColor: 'action.disabledBackground' }, course.sx),
                } }))); }))),
            courses && courses.length === 0 && react_1.default.createElement(material_1.Box, { sx: { my: 1 } }, NoCourseComponent),
            !courses && react_1.default.createElement(il_spinner_1.ILSpinner, { sx: { mb: 2.5 } }),
            children)));
}
exports.StudentCourseCard = StudentCourseCard;
